import { createTheme, ThemeProvider } from "@mui/material/styles";

const colors = createTheme({
    bg: '#351113',
    text: '#FFCF03',
    white: '#FFFFF0',
    // hover: '#351113E5'
});

export default colors;